// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Bootstrap__ToastController from "./bootstrap/toast_controller"
application.register("bootstrap--toast", Bootstrap__ToastController)

import Bootstrap__TooltipController from "./bootstrap/tooltip_controller"
application.register("bootstrap--tooltip", Bootstrap__TooltipController)

import Stripe__EmbeddedCheckoutFormController from "./stripe/embedded_checkout_form_controller"
application.register("stripe--embedded-checkout-form", Stripe__EmbeddedCheckoutFormController)

import TomSelect__SelectController from "./tom_select/select_controller"
application.register("tom-select--select", TomSelect__SelectController)
